import { Box, SxProps, Theme } from "@mui/material";
import { Footer } from "components/Foundation/Footer";
import { Header } from "components/Foundation/Header";

export interface PageWrapperProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const PageWrapper: React.FC<PageWrapperProps> = ({ children, sx }) => {
  return (
    <Box
      display={"flex"}
      minHeight={"100vh"}
      justifyContent={"space-between"}
      flexDirection={"column"}
    >
      <Header />
      <Box
        sx={{
          marginBottom: "auto",
          marginTop: 5,
          paddingX: { xs: 2, lg: 15 },
          paddingBottom: { xs: 5, lg: 15 },
          ...sx,
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  );
};
